import { useSelector } from "react-redux";

import * as Sentry from "@sentry/react";

import { version } from "../../../package.json";

const Version = () => {
  const appVersion = useSelector(
    (state) =>
      state?.authReducer?.appInfo?.version || {
        api: "",
        android: "",
        ios: "",
        referential: "",
      }
  );

  const handleSecretClick = () => {
    Sentry.setUser({
      id: "test-user",
      email: "test@example.com",
    });

    // Add breadcrumb for context
    Sentry.addBreadcrumb({
      message: "User clicked on version component to test Sentry",
      category: "ui.click",
      level: "info",
    });

    // Throw a test error
    throw new Error("This is your first error!");
  };

  return (
    <>
      <div className="version-container">
        <span className="version" title="Version de l'application web"
          onClick={handleSecretClick}
          style={{
            cursor: "pointer",
            userSelect: "none",
            transition: "opacity 0.2s ease",
          }}
          onMouseEnter={(e) =>
            ((e.target as HTMLElement).style.opacity = "0.7")
          }
          onMouseLeave={(e) => ((e.target as HTMLElement).style.opacity = "1")}
        >
          WEB : {version}
        </span>
        <span className="version" title="Version de l'API">
          API : {appVersion.api}
        </span>

        <span className="version" title="Version de l'application Android">
          Android : {appVersion.android}
        </span>
        <span className="version" title="Version de l'application IOS">
          IOS : {appVersion.ios}
        </span>
        <span
          className="version"
          title="Version du référentiel d'état des lieux"
        >
          Référentiel : {appVersion.referential}
        </span>
      </div>
    </>
  );
};

export default Version;
